module.exports = __webpack_public_path__ + "media/images/box-f7b5d90c0db2394eee302398b807926b.png";